"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var Loader = function Loader(props) {
  return React.createElement("svg", props, React.createElement("defs", null, React.createElement("linearGradient", {
    x1: "8.042%",
    y1: "0%",
    x2: "65.682%",
    y2: "23.865%",
    id: "a"
  }, React.createElement("stop", {
    stopColor: "#ff671b",
    stopOpacity: "0",
    offset: "0%"
  }), React.createElement("stop", {
    stopColor: "#ff671b",
    stopOpacity: ".631",
    offset: "63.146%"
  }), React.createElement("stop", {
    stopColor: "#ff671b",
    offset: "100%"
  }))), React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18",
    stroke: "url('#a')",
    strokeWidth: "2"
  }, React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "0.9s",
    repeatCount: "indefinite"
  })), React.createElement("circle", {
    fill: "#fff",
    cx: "36",
    cy: "18",
    r: "1"
  }, React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "0.9s",
    repeatCount: "indefinite"
  }))));
};

Loader.defaultProps = {
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  xmlns: "http://www.w3.org/2000/svg"
};

var LoadingDisplay = function LoadingDisplay(props) {
  return React.createElement(Loader, (0, _tslib.__assign)({}, props));
};

var _default = LoadingDisplay;
exports.default = _default;